import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { User } from "@/hooks/useUsers";

interface UserPasswordFieldProps {
  form: UseFormReturn<Omit<User, "id">>;
  isEditing: boolean;
}

export const UserPasswordField = ({ form, isEditing }: UserPasswordFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="password"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{isEditing ? "Nova Senha (opcional)" : "Senha (opcional)"}</FormLabel>
          <FormControl>
            <div className="relative">
              <Lock className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input 
                className="pl-8" 
                type="password" 
                placeholder={isEditing ? "Digite a nova senha" : "Digite a senha"}
                {...field} 
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};